export const CONTACT_LIMIT = 20;
/** Minimal conservative email normalization; no provider-specific alias rewriting or hashing.
 * Used on selected/transient inputs only. Throws TypeError, never echoes private input. */
export function normalizeContactEmail(value) {
  if (
    typeof value !== 'string' ||
    value.length > 254 ||
    !/^[A-Za-z0-9.!#$%&'*+/=?^_`{|}~-]+@[A-Za-z0-9](?:[A-Za-z0-9.-]*[A-Za-z0-9])?\.[A-Za-z]{2,63}$/.test(
      value.trim(),
    )
  )
    throw new TypeError('Enter a valid email address.');
  return value.trim().toLowerCase();
}
/** Bound an explicitly reviewed batch. Reject unknown metadata; retain no contact names/phones. */
export function validateContactBatch(input) {
  if (
    !input ||
    typeof input !== 'object' ||
    Array.isArray(input) ||
    Object.keys(input).some((key) => !['emails', 'reviewed'].includes(key)) ||
    input.reviewed !== true ||
    !Array.isArray(input.emails) ||
    input.emails.length < 1 ||
    input.emails.length > CONTACT_LIMIT
  )
    throw new TypeError('Review between one and twenty selected email addresses.');
  return [...new Set(input.emails.map(normalizeContactEmail))];
}
/** Mail draft only. Caller owns review/send in their email app; no delivery is inferred. */
export function contactInvitationURL(email, inviter, url) {
  const address = normalizeContactEmail(email);
  const destination = new URL(url);
  if (
    !['http:', 'https:'].includes(destination.protocol) ||
    destination.username ||
    destination.password
  )
    throw new TypeError('Invalid invitation link.');
  const subject = 'Join me on myAudience';
  const body = `${String(inviter).slice(0, 80)} invited you to connect on myAudience.\n\n${destination.href}\n\nThis invitation does not add you to a group or share your contacts.`;
  return `mailto:${encodeURIComponent(address)}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
}
